module.exports = __webpack_public_path__ + "static/media/PFHandbookProItalic.e180680d.woff";